export default __webpack_public_path__ + "static/2467-84caa59ad778085de36c035d8d29769f.gif";